module.exports = __webpack_public_path__ + "media/images/alex-beta-38c7562c.svg";